var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.categories.length
    ? _c("div", { staticClass: "category-slider-widget" }, [
        _vm.title
          ? _c("div", { staticClass: "category-slider-header" }, [
              _c("h2", { staticClass: "category-slider-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "category-slider-wrapper",
            on: {
              mouseenter: function ($event) {
                _vm.showArrows = true
              },
              mouseleave: function ($event) {
                _vm.showArrows = false
              },
            },
          },
          [
            _c(
              "button",
              {
                staticClass: "slider-arrow slider-arrow-prev",
                class: { "is-visible": _vm.showArrows && !_vm.isBeginning },
                attrs: { "aria-label": "Vorherige Kategorie" },
                on: { click: _vm.slidePrev },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                    },
                  },
                  [_c("polyline", { attrs: { points: "15 18 9 12 15 6" } })]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "slider-arrow slider-arrow-next",
                class: { "is-visible": _vm.showArrows && !_vm.isEnd },
                attrs: { "aria-label": "Nächste Kategorie" },
                on: { click: _vm.slideNext },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                    },
                  },
                  [_c("polyline", { attrs: { points: "9 18 15 12 9 6" } })]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { ref: "swiperContainer", staticClass: "swiper" }, [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.categories, function (category, index) {
                  return _c(
                    "div",
                    { key: category.id || index, staticClass: "swiper-slide" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "category-slide-link",
                          attrs: { href: category.url },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "category-slide-image-wrapper" },
                            [
                              _c("img", {
                                staticClass: "category-slide-image",
                                attrs: {
                                  src: category.image,
                                  alt: category.name,
                                  loading: "lazy",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "category-slide-name" }, [
                            _vm._v(_vm._s(category.name)),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }